import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { ParkingService } from '../lib/parking.service'
import { TariffType } from '../lib/parking.types'

const GET_QUICK_INTERVALS = 'get-quick-intervals'

export const useQuickIntervals = () => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  const { data } = useQuery({
    queryKey: [GET_QUICK_INTERVALS, projectId],
    queryFn: () => ParkingService.getQuickIntervals(projectId),
    select: response => response.data,
    staleTime: 0,
    enabled: Boolean(projectId)
  })

  const quickIntervals = useMemo(
    () => ({
      [TariffType.Daily]:
        data?.filter(tariff => tariff.type === TariffType.Daily) ?? [],
      [TariffType.Hourly]:
        data?.filter(tariff => tariff.type === TariffType.Hourly) ?? []
    }),
    [data]
  )

  return { data: quickIntervals }
}
